const InstallationWorkflowPage = () => (
  <div className="p-4">
    <h1 className="text-xl font-bold">Installation Workflow</h1>
  </div>
)

export default InstallationWorkflowPage
